import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { SecondaryButton } from '@components/Button/variants';
import IconError from '@components/Images/Rebranding/IconError';

import Wrapper from './Wrapper';

interface UserStatusProps {
  buttonText: string;
  copy: string;
  linkTo: string;
}

const UserStatus = ({ buttonText, copy, linkTo }: UserStatusProps): JSX.Element => (
  <Wrapper className="bg-grayscale-beige">
    <div className="w-max-[1024px] flex flex-row flex-wrap items-center justify-center gap-16 pb-10 sm:pb-0">
      <IconError fill="#f32a52" width="20" height="20" />
      <div className="text-center font-suisse-neue text-body-md font-normal text-black">
        {ReactHtmlParser(copy)}
      </div>
      <SecondaryButton as="link" href={linkTo} size="small">
        {buttonText}
      </SecondaryButton>
    </div>
  </Wrapper>
);

export default UserStatus;
